// Gurusevakendra - Mock data (bilingual: Odia + English)

export const brand = {
  name: 'Gurusevakendra',
  nameOdia: 'ଗୁରୁ ସେବା କେନ୍ଦ୍ର',
  tagline: 'ଆପଣଙ୍କ ସଫଳତାର ସାଥୀ',
  taglineEn: 'Your Companion for Success',
  email: 'gurusevakendra33@gmail.com',
  phone: '+91 73258 93950',
};

export const stats = [
  { value: '25,000+', label: 'ଛାତ୍ର / Students' },
  { value: '12,000+', label: 'ପାଠ / Lessons' },
  { value: '3,500+', label: 'ପ୍ରଶ୍ନ / Questions' },
  { value: '98%', label: 'ସନ୍ତୁଷ୍ଟି / Rating' },
];

export const mainSections = [
  {
    id: 'navodaya',
    title: 'ନବୋଦୟ ପ୍ରସ୍ତୁତି',
    titleEn: 'Navodaya Preparation',
    subtitle: 'JNVST Class 6 ଓ Class 9',
    icon: 'GraduationCap',
    gradient: 'from-amber-500 via-orange-500 to-rose-500',
    route: '/navodaya',
    badge: 'Popular',
  },
  {
    id: 'board',
    title: 'ଦଶମ ବୋର୍ଡ ପରୀକ୍ଷା',
    titleEn: 'Odisha 10th Board (BSE)',
    subtitle: 'ସମ୍ପୂର୍ଣ୍ଣ ପ୍ରସ୍ତୁତି · Complete prep',
    icon: 'ScrollText',
    gradient: 'from-indigo-500 via-blue-500 to-cyan-500',
    route: '/board',
    badge: 'New',
  },
  {
    id: 'teacher',
    title: 'ଶିକ୍ଷକ ସମ୍ବଳ',
    titleEn: 'Teacher Resources',
    subtitle: 'ବାଳବାଟିକା ରୁ ଦଶମ ଶ୍ରେଣୀ ପାଠ୍ୟ ଯୋଜନା',
    icon: 'BookOpen',
    gradient: 'from-emerald-500 via-teal-500 to-cyan-600',
    route: '/teacher',
    badge: null,
  },
];

// -------- Navodaya --------
export const navodayaLevels = [
  {
    id: 'jnvst-6',
    title: 'JNVST — Class 6',
    titleOdia: 'ଷଷ୍ଠ ଶ୍ରେଣୀ ପ୍ରବେଶିକା',
    duration: '2 ଘଣ୍ଟା · 80 ପ୍ରଶ୍ନ',
    color: 'from-amber-500 to-orange-600',
  },
  {
    id: 'jnvst-9',
    title: 'JNVST — Class 9 (Lateral)',
    titleOdia: 'ନବମ ଶ୍ରେଣୀ ପାର୍ଶ୍ୱ ପ୍ରବେଶ',
    duration: '2.5 ଘଣ୍ଟା · 100 ପ୍ରଶ୍ନ',
    color: 'from-rose-500 to-pink-600',
  },
];

export const navodayaSubjects = {
  'jnvst-6': [
    { name: 'ମାନସିକ ଯୋଗ୍ୟତା', nameEn: 'Mental Ability', chapters: 15, icon: '🧩', color: 'bg-amber-100 text-amber-700' },
    { name: 'ଅଙ୍କଗଣିତ', nameEn: 'Arithmetic', chapters: 20, icon: '🔢', color: 'bg-blue-100 text-blue-700' },
    { name: 'ଭାଷା (ଓଡ଼ିଆ)', nameEn: 'Language (Odia)', chapters: 12, icon: '📖', color: 'bg-emerald-100 text-emerald-700' },
  ],
  'jnvst-9': [
    { name: 'ଇଂରାଜୀ', nameEn: 'English', chapters: 18, icon: '📚', color: 'bg-indigo-100 text-indigo-700' },
    { name: 'ହିନ୍ଦୀ', nameEn: 'Hindi', chapters: 14, icon: '🈴', color: 'bg-rose-100 text-rose-700' },
    { name: 'ଗଣିତ', nameEn: 'Mathematics', chapters: 22, icon: '📐', color: 'bg-purple-100 text-purple-700' },
    { name: 'ବିଜ୍ଞାନ', nameEn: 'Science', chapters: 20, icon: '🔬', color: 'bg-teal-100 text-teal-700' },
  ],
};

export const navodayaFeatures = [
  { title: 'ପାଠ୍ୟ ନୋଟ୍ସ', titleEn: 'Study Notes', icon: 'FileText', gradient: 'from-emerald-500 to-teal-600', route: '/notes/navodaya' },
  { title: 'ମକ୍ ଟେଷ୍ଟ', titleEn: 'Mock Tests', icon: 'ClipboardCheck', gradient: 'from-orange-500 to-amber-600', route: '/navodaya/practice' },
  { title: 'ପୂର୍ବ ପ୍ରଶ୍ନପତ୍ର', titleEn: 'Previous Year Papers', icon: 'FileStack', gradient: 'from-indigo-500 to-blue-600', route: '/sources?for=navodaya', external: true },
  { title: 'ଭିଡିଓ ପାଠ', titleEn: 'Video Lessons', icon: 'PlayCircle', gradient: 'from-rose-500 to-pink-600', soon: true },
  { title: 'ଦୈନିକ କୁଇଜ', titleEn: 'Daily Quiz', icon: 'Zap', gradient: 'from-cyan-500 to-sky-600', route: '/quiz' },
  { title: 'ସନ୍ଦେହ ସମାଧାନ', titleEn: 'AI Doubt Solving', icon: 'MessageSquare', gradient: 'from-violet-500 to-purple-600', route: '/chat' },
];

// -------- Odisha 10th Board --------
export const boardSubjects = [
  { id: 'odia', name: 'ଓଡ଼ିଆ (MIL)', nameEn: 'Odia (MIL)', chapters: 14, color: 'from-emerald-500 to-green-600', icon: '📖' },
  { id: 'english', name: 'ଇଂରାଜୀ', nameEn: 'English', chapters: 12, color: 'from-blue-500 to-indigo-600', icon: '📚' },
  { id: 'hindi', name: 'ହିନ୍ଦୀ / ସଂସ୍କୃତ', nameEn: 'Hindi / Sanskrit', chapters: 10, color: 'from-rose-500 to-red-600', icon: '🈴' },
  { id: 'maths', name: 'ଗଣିତ', nameEn: 'Mathematics', chapters: 15, color: 'from-purple-500 to-violet-600', icon: '📐' },
  { id: 'science', name: 'ବିଜ୍ଞାନ', nameEn: 'Science (Phy + Life)', chapters: 16, color: 'from-teal-500 to-cyan-600', icon: '🔬' },
  { id: 'social', name: 'ସାମାଜିକ ବିଜ୍ଞାନ', nameEn: 'Social Science', chapters: 18, color: 'from-orange-500 to-amber-600', icon: '🌏' },
];

export const boardResources = [
  { title: 'ଅଧ୍ୟାୟ ନୋଟ୍ସ', titleEn: 'Chapter Notes', icon: 'FileText', color: 'from-emerald-500 to-teal-600', route: '/notes/board' },
  { title: 'ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କ', titleEn: 'Question Bank', icon: 'Library', color: 'from-blue-500 to-indigo-600', route: '/notes/teacher?type=question_bank&class=class-10' },
  { title: 'ମଡେଲ୍ ପେପର', titleEn: 'Model Papers (BSE Official)', icon: 'FileCheck2', color: 'from-orange-500 to-red-600', route: '/sources?for=board', external: true },
  { title: 'ପୂର୍ବ ପରୀକ୍ଷା', titleEn: 'Previous Papers (Official)', icon: 'FileStack', color: 'from-purple-500 to-fuchsia-600', route: '/sources?for=board', external: true },
  { title: 'ସୂତ୍ର ପୁସ୍ତିକା', titleEn: 'Formula Book', icon: 'BookMarked', color: 'from-cyan-500 to-blue-600', route: '/notes/teacher?type=book&class=class-10' },
  { title: 'ମାନଚିତ୍ର', titleEn: 'Map Practice', icon: 'Map', color: 'from-rose-500 to-pink-600', route: '/notes/teacher?type=worksheet&class=class-10' },
];

// -------- Teacher Resources --------
export const teacherClasses = ['ବାଳବାଟିକା', 'ଶ୍ରେଣୀ ୧', 'ଶ୍ରେଣୀ ୨', 'ଶ୍ରେଣୀ ୩', 'ଶ୍ରେଣୀ ୪', 'ଶ୍ରେଣୀ ୫', 'ଶ୍ରେଣୀ ୬', 'ଶ୍ରେଣୀ ୭', 'ଶ୍ରେଣୀ ୮', 'ଶ୍ରେଣୀ ୯', 'ଶ୍ରେଣୀ ୧୦'];

export const teacherFeatures = [
  { id: 'lesson-plans', title: 'ପାଠ୍ୟ ଯୋଜନା', titleEn: 'Lesson Plans', subtitle: 'ବାଳବାଟିକା ରୁ ଦଶମ', icon: 'BookOpen', gradient: 'from-emerald-500 to-teal-600', route: '/notes/teacher' },
  { id: 'short-lesson-plans', title: 'ଛୋଟ ପାଠ୍ୟ ଯୋଜନା', titleEn: 'Short Lesson Plans', subtitle: 'ଦୈନିକ ପ୍ରସ୍ତୁତ', icon: 'Star', gradient: 'from-blue-500 to-indigo-600', badge: 'ନୂଆ', route: '/lesson-plan' },
  { id: 'daily-7-period', title: '୭ କାଳ ଯୋଜନା', titleEn: 'Daily 7-Period Plan', subtitle: 'ଏକ କ୍ଲିକ୍ ଜେନେରେଟର', icon: 'CalendarDays', gradient: 'from-violet-500 to-purple-700', soon: true },
  { id: 'multigrade', title: 'ବହୁ-ଶ୍ରେଣୀ ଯୋଜନା', titleEn: 'Multigrade Plan', subtitle: '୨-୫ ଶ୍ରେଣୀ · ଏକ କାଳ', icon: 'School', gradient: 'from-orange-500 to-amber-600', soon: true },
  { id: 'books-library', title: 'ପୁସ୍ତକାଳୟ', titleEn: 'Books Library', subtitle: 'ଅଧ୍ୟାୟ ଅନୁସାରେ PDF', icon: 'Library', gradient: 'from-cyan-500 to-blue-600', route: '/notes/teacher?type=book' },
  { id: 'question-bank', title: 'ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କ', titleEn: 'Question Bank', subtitle: 'ଅଧ୍ୟାୟ-ଭିତ୍ତିକ ଉତ୍ତର', icon: 'FileQuestion', gradient: 'from-rose-500 to-pink-600', route: '/notes/teacher?type=question_bank' },
  { id: 'worksheets', title: 'କାର୍ଯ୍ୟପତ୍ର', titleEn: 'Worksheets', subtitle: 'ପ୍ରିଣ୍ଟଯୋଗ୍ୟ ଅଭ୍ୟାସ', icon: 'FileText', gradient: 'from-purple-500 to-violet-700', route: '/notes/teacher?type=worksheet' },
  { id: 'assessments', title: 'ମୂଲ୍ୟାୟନ', titleEn: 'Assessments', subtitle: 'FA · SA · PDF', icon: 'BarChart3', gradient: 'from-fuchsia-500 to-pink-600', route: '/notes/teacher?type=assessment' },
];

// -------- Testimonials --------
export const testimonials = [
  {
    initial: 'ପ',
    name: 'ପ୍ରଶାନ୍ତ ମହାପାତ୍ର',
    role: 'ଅଭିଭାବକ · Parent',
    rating: 5,
    quote: 'ମୋ ପିଲା Navodaya ପରୀକ୍ଷାରେ ସଫଳ ହୋଇଛି। Gurusevakendra ର ମକ୍ ଟେଷ୍ଟ ଓ ଓଡ଼ିଆ ନୋଟ୍ସ ବହୁତ ସାହାଯ୍ୟ କରିଛି।',
    color: 'bg-emerald-500',
  },
  {
    initial: 'ସ',
    name: 'ସୁସ୍ମିତା ସାହୁ',
    role: 'ଛାତ୍ରୀ · Class 10',
    rating: 5,
    quote: 'BSE Odisha ର ପାଇଁ ସମ୍ପୂର୍ଣ୍ଣ syllabus ଏଠାରେ ମିଳେ। A4 PDF ଡାଉନଲୋଡ ଓ ମଡେଲ୍ ପେପର ବହୁତ ଉପଯୋଗୀ।',
    color: 'bg-indigo-500',
  },
  {
    initial: 'ର',
    name: 'ରାଜେନ୍ଦ୍ର ପାତ୍ର',
    role: 'ଶିକ୍ଷକ · Teacher',
    rating: 5,
    quote: 'ପାଠ୍ୟ ଯୋଜନା ଓ ମୂଲ୍ୟାୟନ ପ୍ରଶ୍ନପତ୍ର ଏକ ସ୍ଥାନରେ ମିଳୁଛି। ଓଡ଼ିଆ ମାଧ୍ୟମ ଶିକ୍ଷକଙ୍କ ପାଇଁ ଏହା ଏକ ଅନନ୍ୟ ମଞ୍ଚ।',
    color: 'bg-amber-500',
  },
];

export const advancedFeatures = [
  { id: 'download-a4', title: 'ଏଏ୪ PDF ଡାଉନଲୋଡ', titleEn: 'A4 PDF Download', icon: 'FileDown', gradient: 'from-emerald-500 to-green-600' },
  { id: 'bookmarks', title: 'ଚିହ୍ନିତ ପାଠ', titleEn: 'Bookmarks', icon: 'Bookmark', gradient: 'from-amber-500 to-orange-600' },
  { id: 'progress', title: 'ଆଗଦାନ ଟ୍ରାକର', titleEn: 'Progress Tracker', icon: 'LineChart', gradient: 'from-blue-500 to-indigo-600' },
  { id: 'quiz', title: 'ଦୈନିକ କୁଇଜ', titleEn: 'Daily Quiz', icon: 'Brain', gradient: 'from-fuchsia-500 to-pink-600' },
  { id: 'timer', title: 'ଅଧ୍ୟୟନ ଟାଇମର', titleEn: 'Study Timer', icon: 'Timer', gradient: 'from-rose-500 to-red-600' },
  { id: 'streak', title: 'ଦୈନିକ ଷ୍ଟ୍ରିକ', titleEn: 'Study Streak', icon: 'Flame', gradient: 'from-orange-500 to-red-500' },
];

// Downloadable notes (A4 printable content) - sample per category

// Chapter notes - original brief educational outlines
export const sampleNotes = {
  navodaya: [
    {
      id: 'nav-math-01', subjectKey: 'arithmetic',
      subject: 'ଅଙ୍କଗଣିତ / Arithmetic',
      chapter: 'ଅଧ୍ୟାୟ ୧ — ସଂଖ୍ୟା ପଦ୍ଧତି',
      chapterEn: 'Chapter 1 — Number System',
      level: 'JNVST — Class 6', pages: 8,
      sections: [
        { heading: 'ପରିଚୟ', body: 'ଗଣିତର ଆଧାର ହେଲା ସଂଖ୍ୟା। ଏହି ଅଧ୍ୟାୟରେ ସଂଖ୍ୟାର ପ୍ରକାର ଓ ଗଣନା ବିଷୟରେ ଜାଣିବା।' },
        { heading: 'ସଂଖ୍ୟାର ପ୍ରକାର', body: '୧। ପ୍ରାକୃତିକ: 1, 2, 3, ...\n୨। ପୂର୍ଣ୍ଣ: 0, 1, 2, ...\n୩। ପୂର୍ଣ୍ଣାଙ୍କ: ..., −2, −1, 0, 1, 2, ...\n୪। ଭଗ୍ନ: 1/2, 3/4\n୫। ଦଶମିକ: 0.5, 2.75' },
        { heading: 'କ୍ରିୟା', body: 'ଚାରି ମୂଳ କ୍ରିୟା: +, −, ×, ÷\nଉଦା: 25+17=42, 12×8=96, 144÷12=12' },
      ],
    },
    {
      id: 'nav-math-02', subjectKey: 'arithmetic',
      subject: 'ଅଙ୍କଗଣିତ / Arithmetic',
      chapter: 'ଅଧ୍ୟାୟ ୨ — ଭଗ୍ନ ଓ ଦଶମିକ',
      chapterEn: 'Chapter 2 — Fractions & Decimals',
      level: 'JNVST — Class 6', pages: 6,
      sections: [
        { heading: 'ଭଗ୍ନ ପରିଚୟ', body: 'ଏକ ବସ୍ତୁକୁ ସମାନ ଭାଗରେ ବିଭାଜନ କଲେ ପ୍ରତ୍ୟେକ ଭାଗ ଭଗ୍ନ। ଉଦା: 1/2, 3/4।' },
        { heading: 'ଯୋଗ-ବିୟୋଗ', body: 'ସମାନ ହରର ଭଗ୍ନ: 1/4 + 2/4 = 3/4\nଅସମାନ ହରର ଭଗ୍ନ: ପ୍ରଥମେ ଲସାଗୁ କାଢ଼ି ଫେର ଯୋଗ କରନ୍ତୁ।' },
        { heading: 'ଦଶମିକ', body: '1/2 = 0.5, 3/4 = 0.75, 1/5 = 0.2' },
      ],
    },
    {
      id: 'nav-math-03', subjectKey: 'arithmetic',
      subject: 'ଅଙ୍କଗଣିତ / Arithmetic',
      chapter: 'ଅଧ୍ୟାୟ ୩ — ଶତକଡ଼ା',
      chapterEn: 'Chapter 3 — Percentage',
      level: 'JNVST — Class 6', pages: 5,
      sections: [
        { heading: 'ଅର୍ଥ', body: 'ପ୍ରତି 100ରୁ ଥିବା ଅଂଶ = ଶତକଡ଼ା। 25% = 100ରୁ 25।' },
        { heading: 'ସୂତ୍ର', body: 'ଶତକଡ଼ା = (ଅଂଶ ÷ ପୂର୍ଣ୍ଣ) × 100' },
        { heading: 'ପ୍ରୟୋଗ', body: '50 ର 20% = 10\n200 ର 15% = 30' },
      ],
    },
    {
      id: 'nav-mat-01', subjectKey: 'mental',
      subject: 'ମାନସିକ ଯୋଗ୍ୟତା / Mental Ability',
      chapter: 'ଅଧ୍ୟାୟ ୧ — ଆକାର ଓ ଆକୃତି',
      chapterEn: 'Chapter 1 — Figure Series',
      level: 'JNVST — Class 6', pages: 6,
      sections: [
        { heading: 'ପରିଚୟ', body: 'ଛାତ୍ରର ଚିନ୍ତନଶକ୍ତି, ଆକାର ଚିହ୍ନଟ ଓ ଅନୁବେଦନ କ୍ଷମତା ଯାଞ୍ଚ ହୁଏ।' },
        { heading: 'ନିୟମ', body: '• ଆକୃତିର ନିୟମ ଚିହ୍ନି ପରବର୍ତ୍ତୀ ଆକାର ନିର୍ଣ୍ଣୟ କରନ୍ତୁ।\n• ଘୁରଣ, ଉଲ୍ଟାନ, ପରିବର୍ତ୍ତନ ଉପରେ ଧ୍ୟାନ ଦିଅନ୍ତୁ।' },
      ],
    },
    {
      id: 'nav-mat-02', subjectKey: 'mental',
      subject: 'ମାନସିକ ଯୋଗ୍ୟତା / Mental Ability',
      chapter: 'ଅଧ୍ୟାୟ ୨ — ଶ୍ରେଣୀ',
      chapterEn: 'Chapter 2 — Number & Letter Series',
      level: 'JNVST — Class 6', pages: 5,
      sections: [
        { heading: 'ସଂଖ୍ୟା ଶ୍ରେଣୀ', body: 'ନିୟମ ଚିହ୍ନି ପରବର୍ତ୍ତୀ ସଂଖ୍ୟା ଅଙ୍କ କରନ୍ତୁ।\nଉଦା: 2, 4, 8, 16, ? → 32 (ପ୍ରତ୍ୟେକ ୨ ଗୁଣିତ)' },
        { heading: 'ଅକ୍ଷର ଶ୍ରେଣୀ', body: 'A, C, E, G, ? → I (ଏକ ଅକ୍ଷର ଛାଡ଼ି)' },
      ],
    },
    {
      id: 'nav-odia-01', subjectKey: 'language',
      subject: 'ଓଡ଼ିଆ ଭାଷା / Odia',
      chapter: 'ଅଧ୍ୟାୟ ୧ — ବର୍ଣ୍ଣ ଓ ଅକ୍ଷର',
      chapterEn: 'Chapter 1 — Alphabet',
      level: 'JNVST — Class 6', pages: 5,
      sections: [
        { heading: 'ସ୍ୱର ବର୍ଣ୍ଣ', body: '୧୪ଟି ସ୍ୱର — ଅ, ଆ, ଇ, ଈ, ଉ, ଊ, ଋ, ଏ, ଐ, ଓ, ଔ, ଅଂ, ଅଃ ଆଦି।' },
        { heading: 'ବ୍ୟଞ୍ଜନ', body: '୩୩ଟି ବ୍ୟଞ୍ଜନ — କ ଠାରୁ କ୍ଷ ଯାଏ।' },
        { heading: 'ମାତ୍ରା ଓ ଫଳା', body: 'ମାତ୍ରା ସ୍ୱର ଚିହ୍ନ (ା, ି, ୀ, ୁ, ୂ, େ, ୈ, ୋ, ୌ)। ଫଳା = ୟ, ର, ଲ, ମ ର ସଂଯୋଗ ରୂପ।' },
      ],
    },
  ],
  board: [
    {
      id: 'brd-sci-01', subjectKey: 'science',
      subject: 'ବିଜ୍ଞାନ / Science',
      chapter: 'ଅଧ୍ୟାୟ ୧ — ରାସାୟନିକ ପ୍ରତିକ୍ରିୟା',
      chapterEn: 'Chapter 1 — Chemical Reactions',
      level: 'BSE — Class 10', pages: 12,
      sections: [
        { heading: 'ପରିଚୟ', body: 'ରାସାୟନିକ ପ୍ରତିକ୍ରିୟାରେ ପଦାର୍ଥର ରାସାୟନିକ ପରିବର୍ତ୍ତନ ଘଟିଥାଏ। ନୂଆ ପଦାର୍ଥ (ଉତ୍ପାଦ) ଉତ୍ପନ୍ନ ହୁଏ।' },
        { heading: 'ସମୀକରଣ', body: 'Zn + 2HCl → ZnCl₂ + H₂↑' },
        { heading: 'ପ୍ରକାର', body: '୧। ସଂଯୋଗ\n୨। ବିଯୋଜନ\n୩। ପ୍ରତିସ୍ଥାପନ\n୪। ଦ୍ୱିଗୁଣ ପ୍ରତିସ୍ଥାପନ' },
      ],
    },
    {
      id: 'brd-sci-02', subjectKey: 'science',
      subject: 'ବିଜ୍ଞାନ / Science',
      chapter: 'ଅଧ୍ୟାୟ ୨ — ଆମ୍ଳ, କ୍ଷାର ଓ ଲବଣ',
      chapterEn: 'Chapter 2 — Acids, Bases & Salts',
      level: 'BSE — Class 10', pages: 10,
      sections: [
        { heading: 'ଆମ୍ଳ', body: 'ଜଳରେ ଦ୍ରବୀଭୂତ ହୋଇ H⁺ ଆୟନ ଉତ୍ପନ୍ନ। pH < 7। ଉଦା: HCl, H₂SO₄।' },
        { heading: 'କ୍ଷାର', body: 'OH⁻ ଆୟନ ଉତ୍ପନ୍ନ କରେ। pH > 7। ଉଦା: NaOH, KOH।' },
        { heading: 'pH ମାପ', body: '0-14। 7 ନିରପେକ୍ଷ। pH paper ମାଧ୍ୟମରେ ପରୀକ୍ଷା।' },
      ],
    },
    {
      id: 'brd-sci-03', subjectKey: 'science',
      subject: 'ବିଜ୍ଞାନ / Science',
      chapter: 'ଅଧ୍ୟାୟ ୩ — ଜୈବ ପ୍ରକ୍ରିୟା',
      chapterEn: 'Chapter — Life Processes',
      level: 'BSE — Class 10', pages: 8,
      sections: [
        { heading: 'ପୋଷଣ', body: 'ପାଦପ: ପ୍ରକାଶ ସଂଶ୍ଳେଷଣ। ପ୍ରାଣୀ: ଅନ୍ୟ ଜୀବଙ୍କ ଉପରେ ନିର୍ଭରଶୀଳ।' },
        { heading: 'ଶ୍ୱାସକ୍ରିୟା', body: 'O₂ ଗ୍ରହଣ, CO₂ ନିର୍ଗତ। ମାନବ ଅଙ୍ଗ: ଫୁସଫୁସ।' },
        { heading: 'ପରିବହନ', body: 'ମାନବ ହୃଦୟ ପମ୍ପ ଭାବରେ କାର୍ଯ୍ୟ କରେ। ଧମନୀ-ଶିରା ମାଧ୍ୟମରେ ରକ୍ତ ପ୍ରବାହ।' },
      ],
    },
    {
      id: 'brd-math-01', subjectKey: 'maths',
      subject: 'ଗଣିତ / Mathematics',
      chapter: 'ଅଧ୍ୟାୟ ୧ — ବାସ୍ତବ ସଂଖ୍ୟା',
      chapterEn: 'Chapter 1 — Real Numbers',
      level: 'BSE — Class 10', pages: 10,
      sections: [
        { heading: 'ଏଉକ୍ଲିଡ ସଂଭାଗନ ନ୍ୟାୟ', body: 'a = bq + r, ଯେଉଁଠାରେ 0 ≤ r < b।' },
        { heading: 'ଅଭାଜ୍ୟ ଓ ଅନଭାଜ୍ୟ', body: 'ଅଭାଜ୍ୟ (Rational): p/q ଆକାରରେ ଲେଖା ଯାଏ। ଉଦା: 2/3\nଅନଭାଜ୍ୟ (Irrational): p/q ଆକାରରେ ଲେଖା ଯାଏ ନାହିଁ। ଉଦା: √2, π' },
      ],
    },
    {
      id: 'brd-math-02', subjectKey: 'maths',
      subject: 'ଗଣିତ / Mathematics',
      chapter: 'ଅଧ୍ୟାୟ ୨ — ବହୁପଦୀ',
      chapterEn: 'Chapter 2 — Polynomials',
      level: 'BSE — Class 10', pages: 9,
      sections: [
        { heading: 'ପରିଚୟ', body: 'p(x) = aₙxⁿ + ... + a₀ ଆକାରର ଅଭିବ୍ୟକ୍ତି। n = ଡିଗ୍ରୀ।' },
        { heading: 'ପ୍ରକାର', body: 'ଡିଗ୍ରୀ 1: ରୈଖିକ\nଡିଗ୍ରୀ 2: ଦ୍ୱିଘାତ\nଡିଗ୍ରୀ 3: ତ୍ରିଘାତ' },
      ],
    },
    {
      id: 'brd-math-03', subjectKey: 'maths',
      subject: 'ଗଣିତ / Mathematics',
      chapter: 'ଅଧ୍ୟାୟ ୩ — ତ୍ରିକୋଣମିତି',
      chapterEn: 'Chapter — Trigonometry',
      level: 'BSE — Class 10', pages: 12,
      sections: [
        { heading: 'ମୌଳିକ ଅନୁପାତ', body: 'sin θ = ବିପରୀତ/କର୍ଣ୍ଣ\ncos θ = ପାର୍ଶ୍ୱ/କର୍ଣ୍ଣ\ntan θ = ବିପରୀତ/ପାର୍ଶ୍ୱ' },
        { heading: 'ଏକକ ମାନ', body: 'sin 0°=0, 30°=½, 45°=1/√2, 60°=√3/2, 90°=1' },
      ],
    },
    {
      id: 'brd-odia-01', subjectKey: 'odia',
      subject: 'ଓଡ଼ିଆ MIL / Odia',
      chapter: 'ଅଧ୍ୟାୟ ୧ — କବିତା ପାଠ',
      chapterEn: 'Chapter — Poetry Study',
      level: 'BSE — Class 10', pages: 7,
      sections: [
        { heading: 'ପାଠ ପଦ୍ଧତି', body: 'କବିତାର ମୂଳ ଭାବ, ପ୍ରତିପାଦ୍ୟ, ଓ ଛନ୍ଦ ବିଷୟରେ ଧ୍ୟାନ ଦିଅନ୍ତୁ।' },
        { heading: 'ଆଧୁନିକ କବି', body: 'ରାଧାନାଥ ରାୟ, ଫକୀରମୋହନ ସେନାପତି, ଗଙ୍ଗାଧର ମେହେର, ମାୟାଧର ମାନସିଂହ।' },
        { heading: 'ପ୍ରଶ୍ନ', body: '• ମୂଳ ଭାବ କ\'ଣ?\n• କାହା ପାଇଁ ଲେଖା?\n• ଅଳଙ୍କାର କେଉଁ?' },
      ],
    },
    {
      id: 'brd-eng-01', subjectKey: 'english',
      subject: 'ଇଂରାଜୀ / English',
      chapter: 'Grammar Basics',
      chapterEn: 'English Grammar',
      level: 'BSE — Class 10', pages: 6,
      sections: [
        { heading: 'Tenses', body: 'Present: I go / I am going / I have gone\nPast: I went / I was going / I had gone\nFuture: I will go / I will have gone' },
        { heading: 'Active vs Passive', body: 'Active: He writes a letter.\nPassive: A letter is written by him.' },
        { heading: 'Common Errors', body: '• Between (2), Among (3+)\n• Fewer (countable), Less (uncountable)' },
      ],
    },
    {
      id: 'brd-hindi-01', subjectKey: 'hindi',
      subject: 'ହିନ୍ଦୀ / Hindi',
      chapter: 'अध्याय — व्याकरण',
      chapterEn: 'Hindi Grammar',
      level: 'BSE — Class 10', pages: 5,
      sections: [
        { heading: 'संज्ञा', body: 'व्यक्ति, वस्तु, स्थान का नाम। प्रकार: व्यक्तिवाचक, जातिवाचक, भाववाचक।' },
        { heading: 'सर्वनाम', body: 'संज्ञा के स्थान पर। जैसे: मैं, तुम, वह, हम।' },
        { heading: 'क्रिया', body: 'कार्य दर्शाने वाले शब्द। जैसे: पढ़ना, लिखना।' },
      ],
    },
    {
      id: 'brd-social-01', subjectKey: 'social',
      subject: 'ସାମାଜିକ ବିଜ୍ଞାନ / Social',
      chapter: 'ଇତିହାସ — ସ୍ୱାଧୀନତା ସଂଗ୍ରାମ',
      chapterEn: 'History — Independence',
      level: 'BSE — Class 10', pages: 10,
      sections: [
        { heading: 'ପ୍ରମୁଖ ଘଟଣା', body: '୧୮୫୭ - ପ୍ରଥମ ସଂଗ୍ରାମ\n୧୮୮୫ - INC ପ୍ରତିଷ୍ଠା\n୧୯୨୦ - ଅସହଯୋଗ\n୧୯୪୨ - ଭାରତ ଛାଡ଼\n୧୯୪୭ - ସ୍ୱାଧୀନତା' },
        { heading: 'ପ୍ରମୁଖ ନେତା', body: 'ମହାତ୍ମା ଗାନ୍ଧୀ, ନେହେରୁ, ସୁଭାଷ ବୋଷ, ପଟେଲ, ଡଃ ଆମ୍ବେଡକର।' },
      ],
    },
    {
      id: 'brd-social-02', subjectKey: 'social',
      subject: 'ସାମାଜିକ ବିଜ୍ଞାନ / Social',
      chapter: 'ଭୂଗୋଳ — ଭାରତ ଓ ଓଡ଼ିଶା',
      chapterEn: 'Geography — India & Odisha',
      level: 'BSE — Class 10', pages: 8,
      sections: [
        { heading: 'ଭାରତ', body: 'ଉତ୍ତର ଗୋଲାର୍ଦ୍ଧରେ, ଏସୀୟା ମହାଦେଶର ଦକ୍ଷିଣରେ। ୭ ପ୍ରତିବେଶୀ ଦେଶ।' },
        { heading: 'ଓଡ଼ିଶା', body: 'ରାଜଧାନୀ: ଭୁବନେଶ୍ୱର\nନଦୀ: ମହାନଦୀ, ବ୍ରାହ୍ମଣୀ, ବୈତରଣୀ\nସ୍ଥାନ: ପୁରୀ, କୋଣାର୍କ, ଚିଲିକା' },
      ],
    },
  ],
  teacher: [
    {
      id: 'tea-plan-01', subjectKey: 'class-5',
      subject: 'ଓଡ଼ିଆ ଭାଷା / Odia',
      chapter: 'ଶ୍ରେଣୀ ୫ — ଜୁଲାଇ ପାଠ୍ୟ ଯୋଜନା',
      chapterEn: 'Class 5 — July Plan',
      level: 'Teacher Resource', pages: 4,
      sections: [
        { heading: 'ମାସିକ ଲକ୍ଷ୍ୟ', body: '• ପଠନ ଓ ଲେଖନ ଦକ୍ଷତା\n• ବ୍ୟାକରଣ ଉନ୍ନତି\n• କାହାଣୀ ମାଧ୍ୟମରେ ମୂଲ୍ୟବୋଧ' },
        { heading: 'ପାଠ ତାଲିକା', body: 'ପାଠ ୧: ଚିତ୍ର ଦେଖୁ\nପାଠ ୨: ବଡ଼ କିଏ?\nପାଠ ୩: ଚଟିଆ\nପାଠ ୪: ସଭିଏଁ ଆମର ମିତ' },
        { heading: 'ମୂଲ୍ୟାୟନ', body: 'ମୌଖିକ, ଆଦାନ-ପ୍ରଦାନ, ଲିଖିତ (୫ ଓ ୧୦ ନମ୍ବର)।' },
      ],
    },
    {
      id: 'tea-plan-02', subjectKey: 'class-3',
      subject: 'ଗଣିତ / Math',
      chapter: 'ଶ୍ରେଣୀ ୩ — ଯୋଗ ଓ ବିୟୋଗ',
      chapterEn: 'Class 3 — Addition & Subtraction',
      level: 'Teacher Resource', pages: 3,
      sections: [
        { heading: 'ଉଦ୍ଦେଶ୍ୟ', body: '୩ ଅଙ୍କ ପର୍ଯ୍ୟନ୍ତ ଯୋଗ-ବିୟୋଗ କରିପାରିବେ।' },
        { heading: 'TLM', body: '• ସଂଖ୍ୟା କାର୍ଡ\n• କାଠ ପାତ୍ର\n• ଅବାକସ' },
        { heading: 'କାର୍ଯ୍ୟକଳାପ', body: '• ମୌଖିକ ଅଭ୍ୟାସ\n• ଜୋଡ଼ାରେ କାର୍ଯ୍ୟ\n• ଘର ପାଇଁ ୫ଟି ପ୍ରଶ୍ନ' },
      ],
    },
    {
      id: 'tea-plan-03', subjectKey: 'balvatika',
      subject: 'ବାଳବାଟିକା / Balvatika',
      chapter: 'ଅକ୍ଷର ଓ ଅଙ୍କ ପରିଚୟ',
      chapterEn: 'Balvatika — Alphabet & Numbers',
      level: 'Teacher Resource', pages: 3,
      sections: [
        { heading: 'ଅକ୍ଷର', body: 'ଚିତ୍ର ମାଧ୍ୟମରେ ଅ ଆ ଇ ଈ ପରିଚୟ। ଗାନ, ଖେଳ, କାହାଣୀ।' },
        { heading: 'ଅଙ୍କ', body: '୧ ରୁ ୧୦ ପର୍ଯ୍ୟନ୍ତ। ଆଙ୍ଗୁଠି ଗଣନା, ବସ୍ତୁ ଗଣନା।' },
      ],
    },
  ],
};


export const premiumPlans = [
  {
    id: 'monthly', name: 'ମାସିକ · Monthly', price: 149, period: '/ମାସ',
    features: ['ସମସ୍ତ ପାଠ୍ୟ ନୋଟ୍ସ', 'ମକ୍ ଟେଷ୍ଟ ପ୍ରବେଶ', 'ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କ', 'PDF ଡାଉନଲୋଡ'],
    popular: false,
  },
  {
    id: 'quarterly', name: 'ତ୍ରୈମାସିକ · Quarterly', price: 399, period: '/୩ ମାସ',
    features: ['ମାସିକରେ ଥିବା ସବୁ', 'ପ୍ରାଥମିକତା ସହାୟତା', 'ଭିଡିଓ ପାଠ', 'ମଡେଲ୍ ପେପର', '୧୧% ସଞ୍ଚୟ'],
    popular: true,
  },
  {
    id: 'yearly', name: 'ବାର୍ଷିକ · Yearly', price: 1299, period: '/ବର୍ଷ',
    features: ['ତ୍ରୈମାସିକରେ ଥିବା ସବୁ', 'ସନ୍ଦେହ ସମାଧାନ', 'ଆଗତ ମକ୍ ଟେଷ୍ଟ', 'ପ୍ରଥମ ଅଭିଗମ୍ୟତା', '୨୭% ସଞ୍ଚୟ'],
    popular: false,
  },
];

export const upcomingEvents = [
  { title: 'JNVST ୨୦୨୬ Class 6 Registration', titleOdia: 'ନବୋଦୟ ୨୦୨୬ ପଞ୍ଜୀକରଣ', date: '୧୫ ଅଗଷ୍ଟ', tag: 'Navodaya', color: 'bg-orange-100 text-orange-700' },
  { title: 'Board Exam Model Paper Set-A Release', titleOdia: 'ମଡେଲ୍ ପେପର ସେଟ୍-A', date: '୨୨ ଅଗଷ୍ଟ', tag: 'Board', color: 'bg-blue-100 text-blue-700' },
  { title: 'Free Live Doubt Class (Maths)', titleOdia: 'ମାଗଣା ସନ୍ଦେହ ଶ୍ରେଣୀ (ଗଣିତ)', date: '୨୮ ଅଗଷ୍ଟ', tag: 'Live', color: 'bg-emerald-100 text-emerald-700' },
];
